import { EntityType } from "@/queries/folder-entities/types";

export type NewItemEntityType = Exclude<EntityType, EntityType.DATASET | EntityType.REPORT>;

export interface NewItemTypeConfig {
  type: NewItemEntityType;
  description: string;
  badge?: string;
}

// Shared source of truth for all "create new" menus.
export const ITEM_TYPE_GROUPS: NewItemTypeConfig[][] = [
  [{ type: EntityType.FOLDER, description: "Organize your work" }],
  [
    {
      type: EntityType.SMART_TABLE,
      description: "Create an interactive table",
      badge: "New",
    },
    { type: EntityType.PROMPT, description: "Design a new prompt" },
    { type: EntityType.WORKFLOW, description: "Create a workflow" },
  ],
  [
    { type: EntityType.INPUT_VARIABLE_SET, description: "Manage input variables" },
    { type: EntityType.TOOL, description: "Create a reusable tool" },
    { type: EntityType.SKILL_COLLECTION, description: "Create a skill collection" },
  ],
  [
    { type: EntityType.SNIPPET, description: "Create a text snippet" },
    { type: EntityType.AB_TEST, description: "Run experiments" },
  ],
];

export const NEW_ITEM_TYPES = ITEM_TYPE_GROUPS.flatMap(group => group.map(item => item.type));

// All creatable item types (excluding folder)
export const ITEM_TYPES = ITEM_TYPE_GROUPS.flatMap(group =>
  group.filter(item => item.type !== EntityType.FOLDER),
);
